import React from 'react';
import MD_HMReview from './MD_HM_Review';
import '../../../CommonCSS/SocietyCSS.css'

const MDHMReviewApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Director/HM Daily Review</h5>
          </div>
        </div>
        <MD_HMReview />
      </div>
    </div >
  );
};

export default MDHMReviewApp;
